import { CommonEnums } from '../../common.enums';

export class JsonC_Inst {
    jsonc_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.jsonc_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    get PrimaryKey(): string {
        return this.jsonc_Inst_Id + '.' + this.dxFlow_Id;
    }

    copy(): JsonC_Inst {
        let jsoncTmp: JsonC_Inst = new JsonC_Inst();

        jsoncTmp.jsonc_Inst_Id = this.jsonc_Inst_Id;
        jsoncTmp.nm = this.nm;
        jsoncTmp.description = this.description;
        jsoncTmp.ver = this.ver;
        jsoncTmp.valid_Cd = this.valid_Cd;
        jsoncTmp.dxFlow_Id = this.dxFlow_Id;
        jsoncTmp.updateBy = this.updateBy;
        jsoncTmp.lastUpdateBy = this.lastUpdateBy;
        jsoncTmp.updateDt = this.updateDt;
        jsoncTmp.disableFlg = this.disableFlg;
        jsoncTmp.src_ConnNm = this.src_ConnNm;
        jsoncTmp.tgt_ConnNm = this.tgt_ConnNm;
        jsoncTmp.retryEnabled = this.retryEnabled;
        jsoncTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        jsoncTmp.retryWaitTime = this.retryWaitTime;

        return jsoncTmp;
    }

    copyFrom(jsoncTmp: JsonC_Inst): void {
        this.jsonc_Inst_Id = jsoncTmp.jsonc_Inst_Id;
        this.nm = jsoncTmp.nm;
        this.description = jsoncTmp.description;
        this.ver = jsoncTmp.ver;
        this.valid_Cd = jsoncTmp.valid_Cd;
        this.dxFlow_Id = jsoncTmp.dxFlow_Id;
        this.updateBy = jsoncTmp.updateBy;
        this.lastUpdateBy = jsoncTmp.lastUpdateBy;
        this.updateDt = jsoncTmp.updateDt;
        this.disableFlg = jsoncTmp.disableFlg;
        this.src_ConnNm = jsoncTmp.src_ConnNm;
        this.tgt_ConnNm = jsoncTmp.tgt_ConnNm;
        this.retryEnabled = jsoncTmp.retryEnabled;
        this.numOfRetryAttempts = jsoncTmp.numOfRetryAttempts;
        this.retryWaitTime = jsoncTmp.retryWaitTime;
    }

    compare(jsoncTmp: JsonC_Inst): string {
        let jsoncString: string = this.toString(false);
        let jsoncTmpString: string = jsoncTmp.toString(false);

        if (jsoncString != jsoncTmpString) {
            return jsoncString + ', ' + jsoncTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Jsonc_Inst [jsonc_Inst_Id=" + this.jsonc_Inst_Id +
            ", nm=" + this.nm + ", description=" + this.description +
            ", ver=" + this.ver + ", updateBy=" + this.updateBy +", updateDt=" + this.updateDt +
            ", valid_Cd=" + this.valid_Cd + ", dxFlow_Id=" + this.dxFlow_Id + ", disableFlg=" + this.disableFlg +
            ",retryEnabled =" + this.retryEnabled +
            ",numOfRetryAttempts="+ this.numOfRetryAttempts +
           ", retryWaitTime= "+ this.retryWaitTime;
        if (isNotCompare) {
            str += ", lastUpdateBy=" + this.lastUpdateBy+
            ", src_ConnNm=" + this.src_ConnNm +
            ", tgt_ConnNm=" + this.tgt_ConnNm;

        }  
        str += ']';
        return str;
    }
}
